import Service from '../services/NotificationsService';
import Auth from '../services/AuthService';

export default {
    namespaced: true,

    state: {
        notifications: [],
        displayNotifications: [],
        loaded: false,
        loading: false,
        showDrawer: false,
        permission: undefined,
    },

    getters: {
        unreadNotifications (state) {
            return state.notifications.filter(notification => !notification.pivot || notification.pivot.read_at === null);
        },
        hasUnread (state, getters) {
            return getters.unreadNotifications.length > 0;
        },
    },

    actions: {
        loadNotifications ({commit, dispatch, state}) {
            commit('setLoading', true);
            window.Echo.leave('notifications.' + Auth.user.id);
            Service.index().then(res => {
                commit('setNotifications', res.data);
                commit('setLoaded', true);
                commit('setLoading', false);

                const channel = window.Echo.private('notifications.' + Auth.user.id);
                channel.listen('NotificationSent', $event => {
                    commit('pushNotification', $event.notification);
                    commit('pushDisplayNotification', $event.notification);
                });
                channel.listen('NotificationRead', $event => {
                    dispatch('loadNotifications');
                    commit('spliceDisplayNotification', $event.notification);
                })
            });
        },

        dismiss({commit}, notification) {
            Service.markAsRead(notification.id).then();
            commit('spliceDisplayNotification', notification);
        },

        doAction ({commit}, notification) {
            Service.markAsRead(notification.id).then(() => {
                if (!notification.action_url && !notification.action_text) {
                    return;
                }
                if (notification.action_text.toLowerCase() === 'refresh' && !notification.action_url) {
                    window.location.reload();
                    return;
                }
                window.location.assign(notification.action_url);
            });
            commit('spliceDisplayNotification', notification);
        },

        async requestPermission({commit}) {
            try {
                const result = await Notification.requestPermission();
                commit('setPermission', result);
            } catch (error) {
                console.error(error)
            }
        },
    },

    mutations: {
        setLoading(state, loading) {
            state.loading = loading;
        },

        setLoaded(state, loaded) {
            state.loaded = loaded;
        },

        setNotifications(state, notifications) {
            state.notifications = notifications;
        },

        pushNotification(state, notification) {
            state.notifications.push(notification);
        },

        pushDisplayNotification(state, notification) {
            state.displayNotifications.push(notification);
        },
        
        spliceDisplayNotification(state, notification) {
            const index = state.displayNotifications.findIndex(n => n.id === notification.id);
            if (index < 0) {
                return;
            }
            state.displayNotifications.splice(index, 1);
        },

        toggleDrawer (state) {
            state.showDrawer = !state.showDrawer;
        },

        setPermission(state, permission) {
            state.permission = permission;
        },
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/store/notifications.js